import URL from 'Constants/apiUrls'
//dev
export const bucket = {
  config: {
    region: ``,
    accessKeyId: ``,
    secretAccessKey: ``,
  },
  name: ``,
}

const createBucketName = () => {
  if (URL.BASE.split('.').length === 3) return 'prod'
  else return URL.BASE.split('.')[1]
}

export const buckets = {
  irPhotos: createBucketName() === 'prod' ? `conduit-${createBucketName()}.obwoirphotos` : `conduit-${createBucketName()}-obwoirphotos`,
}
